import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getFlagData } from "../components/Database";
import Results from "./Results";

const SharedFlag = () => {
  const { uuid } = useParams();

  const [flagData, setFlagData] = useState(null);

  const retrieveFlagData = useCallback(async () => {
    return await getFlagData(uuid);
  });

  useEffect(() => {
    retrieveFlagData().then((data) => {
      setFlagData(data);
    });
  }, []);

  return (
    <div>
      {flagData !== null && <Results data={flagData} previous={null} />}
    </div>
  );
};

export default SharedFlag;
